<template>
  <Teleport to="body">
    <div
      class="modal fade"
      :id="modalId"
      ref="modalElement"
      tabindex="-1"
      :aria-labelledby="titleId"
      :aria-describedby="descId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fw-bold h5" :id="titleId">
              {{ title }}
            </h1>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              @click="stay"
            ></button>
          </div>
          <div :id="descId" class="modal-body">
            {{ body }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="stay">
              {{ cancelLabel }}
            </button>
            <button
              type="button"
              :class="['btn', confirmButtonClass]"
              @click="proceedAnyway"
            >
              {{ confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  name: "WarningModal",
  props: {
    modalId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "Incomplete measurements"
    },
    body: {
      type: String,
      default: ""
    },
    cancelLabel: {
      type: String,
      default: "Cancel"
    },
    confirmLabel: {
      type: String,
      default: "Continue"
    },
    confirmButtonClass: {
      type: String,
      default: "btn-outline-primary"
    }
  },
  emits: ["proceed", "dismiss"],
  data() {
    return {
      modalInstance: null,
      closedByProceed: false
    };
  },
  computed: {
    titleId() {
      return `${this.modalId}-title`;
    },
    descId() {
      return `${this.modalId}-desc`;
    }
  },
  methods: {
    showModal() {
      this.closedByProceed = false;
      this.modalInstance?.show();
    },
    hideModal() {
      this.modalInstance?.hide();
    },
    stay() {
      this.hideModal();
    },
    proceedAnyway() {
      this.closedByProceed = true;
      this.$emit("proceed");
      this.hideModal();
    },
    onModalHidden() {
      if (this.closedByProceed) {
        this.closedByProceed = false;
        return;
      }
      this.$emit("dismiss");
    }
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.modalElement;
      if (el) {
        this.modalInstance = new Modal(el, {
          backdrop: true,
          keyboard: true,
          focus: true
        });
        el.addEventListener("hidden.bs.modal", this.onModalHidden);
      }
    });
  },
  beforeUnmount() {
    const el = this.$refs.modalElement;
    if (el) {
      el.removeEventListener("hidden.bs.modal", this.onModalHidden);
    }
    if (this.modalInstance) {
      this.modalInstance.dispose();
    }
  }
};
</script>
